import { IAttachment } from '~/client/graph'

import LocationBase from './LocationObjects/LocationBase'
import Workflow from './Workflow'

export enum LogisticItemApp {
  FORM = 'Form',
}

interface IBaseLogisticItem {
  id: string
  entityId: string
  app: LogisticItemApp
  name: string
  locations: LocationBase[]
  equipment: LocationBase[]
  status: string
  workflowStepLevel?: number
  type?: string
  formCategoryId?: string
  formInitialType?: string
  companyIds?: string[]
  responsibleContactIds?: string[]
  startDate?: number
  endDate?: number
  isStatusLate?: boolean
  attachments?: IAttachment[]
  isShared?: boolean
  code?: string
  shortName?: string
}

export interface ILogisticItemWorkflow extends IBaseLogisticItem {
  app: LogisticItemApp.FORM
  original: Workflow
  projectId?: string
}

type ILogisticItem = IBaseLogisticItem | ILogisticItemWorkflow

export default ILogisticItem
